// removed by extract-text-webpack-plugin
module.exports = {"section":"_2VLO8","featuredItemsListDesktop":"_1lEL9","buttonSection":"_1tnqM"};